import React from 'react';
import { Stack } from '@mui/material';

import LoaderOverlay from '../../../common/elements/Loader/LoaderOverlay';

import './FiltersContainer.scss';

export default function FiltersContainer({ children, loading }) {
  return (
    <div className="filters-container">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: 'center'
        }}
      >
        {children}
      </Stack>
      {loading && <LoaderOverlay light={true} />}
    </div>
  );
}
